import styles from "~/components/Faq/FaqHeader.module.scss";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Image from '@referralexchange/rea-ui-react/src/atoms/Image';
import { faSearch } from "@fortawesome/pro-light-svg-icons";

const FaqHeader = ({
  handleSearch,
  handleEnterPress,
  handleSearchSubmit,
  search,
  selectedPill,
}) => {
  const title = () => {
    if (selectedPill?.label) {
      return selectedPill.label.charAt(0).toLowerCase() === "f"
        ? `FAQs ${
            selectedPill.label.charAt(0).toLowerCase() +
            selectedPill.label.slice(1)
          }`
        : `FAQs on ${selectedPill.label}`;
    } else {
      return "FAQs";
    }
  };

  return (
    <div className={styles["FaqHeader"]}>
      <div className={styles["FaqHeader__text-content-wrapper"]}>
        <div className={styles["FaqHeader__text-content"]}>
          <h1 className={styles["FaqHeader__main-heading"]}>{title()}</h1>
          <p className={styles["FaqHeader__sub-text"]}>
            Ask a question or search for a phrase
          </p>
          <div className={styles["FaqHeader__search-wrapper"]}>
            <input
              className={styles["FaqHeader__search-input"]}
              placeholder={"Search"}
              name={"search"}
              type={"text"}
              value={search}
              onChange={(e) => handleSearch(e.target.value)}
              onKeyDown={(e) => handleEnterPress(e)}
            />
            <button
              className={styles["FaqHeader__search-button"]}
              aria-label={`Search button`}
              onClick={handleSearchSubmit}
            >
              <FontAwesomeIcon
                icon={faSearch}
                color={"#fff"}
                size="lg"
                className={styles["FaqHeader__search-button-icon"]}
              />
            </button>
          </div>
        </div>
      </div>
      <div className={styles["FaqHeader__image-content"]}>
        <Image
          containerClassName={
            styles["FaqHeader__image-content__image-container"]
          }
          imageSrc={"/static/images/faq-header-image.min.webp"}
          alt={"Lady writing at desk"}
        />
      </div>
    </div>
  );
};

export default FaqHeader;
